<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0 ml-2" style="font-size: 16px">Allergies</h4>
      <a
        href="#"
        v-if="hasCurrentUserPermissionAccess('patients', 'create')"
        style="font-size: 14px"
        @click.prevent="$emit('onEdit', 3)"
      >
        Edit
      </a>
    </div>
    <div
      v-for="allergy in eoc.patient.allergies"
      :key="allergy.id"
      class="d-flex flex-column border-top mt-2 allergy"
    >
      <div class="allergy-field">
        <strong>Type: </strong>
        <span>{{ allergy.allergyType.name }}</span>
      </div>
      <div v-if="allergen(allergy)" class="allergy-field">
        <strong>Allergen: </strong>
        <span>{{ allergen(allergy) }}</span>
      </div>
      <div v-if="reaction(allergy)" class="allergy-field">
        <strong>Reaction: </strong>
        <span>
          {{ reaction(allergy) }}
        </span>
      </div>
      <div v-if="allergy.severity" class="allergy-field">
        <strong>Severity: </strong>
        <span>
          {{ allergy.severity.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EocViewSummaryAllergies",
  props: ["eoc"],
  methods: {
    reaction(allergy) {
      return allergy.otherReaction
        ? allergy.otherReaction
        : allergy.reaction
        ? allergy.reaction.name
        : null;
    },
    allergen(allergy) {
      return allergy.otherAllergen
        ? allergy.otherAllergen
        : allergy.allergen
        ? allergy.allergen.name
        : null;
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"])
  }
};
</script>

<style scoped>
.allergy {
  font-size: 14px;
  padding: 8px;
}
.allergy:last-of-type {
  padding-bottom: 0;
}
.allergy > .allergy-field:not(:last-of-type) {
  margin-bottom: 8px;
}
</style>
